/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Biochemistry18Inputs */

const en__field__enum_studyprograms_study_biochemistry18 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biochemistry18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemistry`)
};

const de__field__enum_studyprograms_study_biochemistry18 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biochemistry18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemie`)
};

/**
* | output |
* | --- |
* | "Biochemistry" |
*
* @param {_Field__Enum_Studyprograms_Study_Biochemistry18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_biochemistry18 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Biochemistry18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Biochemistry18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_biochemistry18(inputs)
	return de__field__enum_studyprograms_study_biochemistry18(inputs)
});
export { _field__enum_studyprograms_study_biochemistry18 as "_field__enum_studyPrograms_STUDY_BIOCHEMISTRY" }